import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  sx?: SxProps<Theme>;
}

const Logo: React.FC<LogoProps> = ({ size = 'medium', sx }) => {
  const sizeMap = {
    small: {
      height: 30,
    },
    medium: {
      height: 40,
    },
    large: {
      height: 60,
    },
  };
  
  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center',
      ...sx
    }}>
      <img
        src="/New Suprie logo with name.svg"
        alt="Suprie Logo"
        style={{
          height: sizeMap[size].height,
          width: 'auto',
          objectFit: 'contain',
        }}
      />
    </Box>
  );
};

export default Logo; 